import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Authority } from 'src/app/shared/models/security/authority';
import { User } from 'src/app/shared/models/security/user';
import { FacadeService } from '../../services/facade.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
	/* Listing des liens accessibles depuis le menu */
	menuItems: {
		name: string;
		path: string;
		parentPath: string;
		iconClass: string;
	}[] = [];

	/**
	 * Id du role de l'utilisateur
	 */
	authorityId: number;
	isPrescriber: boolean = false;

	currentUserLoggedIn: User;

	/* Toggle de la side navbar */
	@Input() isSidebardHidden: boolean = true;
	@Output() toggleSidebarPinEmitter: EventEmitter<any> = new EventEmitter();

	constructor(private facade: FacadeService, protected router: Router) {}

	ngOnInit(): void {
		const user: User = this.facade.dataStorageService.getUser();
		if (user) {
			this.authorityId = user.role.id;
		}

		this.isPrescriber = this.authorityId === Authority.PRESCRIPTEUR;

		this.currentUserLoggedIn = user;

		this.initNavbar();
	}

	/**
	 * Initialise les éléments du tableau représentant la navbar
	 * @param authority id du role
	 */
	initNavbar(): void {
		if (this.authorityId === null || this.authorityId === 0) {
			this.authorityId = this.facade.dataStorageService.getUser()?.role.id;
		}
		const hasAccessToData: boolean =
			this.authorityId === Authority.PLANIFICATEUR ||
			this.authorityId === Authority.CHARGE_MISSION ||
			this.authorityId === Authority.PROFESSIONNEL_SAE;

		if (hasAccessToData) {
			this.menuItems.push({
				name: 'Tableau de bord',
				path: '/dashboard',
				parentPath: '/dashboard',
				iconClass: 'bi bi-house-door-fill'
			});
			this.menuItems.push({
				name: 'Gestion des données',
				path: '/gestion/formations',
				parentPath: '/gestion',
				iconClass: 'bi bi-folder-fill'
			});
		}

		if (hasAccessToData || this.authorityId === Authority.INTERVENANT) {
			this.menuItems.push({
				name: 'Planning',
				path: '/planning',
				parentPath: '/planning',
				iconClass: 'bi bi-calendar-event-fill'
			});
		}

		if (
			hasAccessToData &&
			(this.facade.dataStorageService.isSAAD() ||
				this.facade.dataStorageService.isSSIAD())
		) {
			this.menuItems.push({
				name: 'Tournées',
				path: '/routes/etude',
				parentPath: '/routes',
				iconClass: 'bi bi-geo-alt-fill'
			});
		}
		if (hasAccessToData && !this.facade.dataStorageService.isSSIAD()) {
			this.menuItems.push({
				name: 'Rapports',
				path: '/reports',
				parentPath: '/reports',
				iconClass: 'bi bi-clipboard-data-fill'
			});
		}
	}

	toggleSidebarPin() {
		this.toggleSidebarPinEmitter.emit();
	}
}
